import { modalNavigationDrawerContentStyles } from './ModalNavigationDrawerContent.styles';
export const navigationDrawerContentVariantStyles = {
    modal: modalNavigationDrawerContentStyles,
};
